import React, { forwardRef, useState, useEffect } from 'react';
import OrganisationType from '../OrganisationType';
import OrganisationAbnAcn from '../OrganisationAbnAcn';
import styles from './OrganisationWrapped.module.scss';
import ErrorMsg from '../ErrorMsg';

const OrganisationWrapped = (props, ref) => {
  const REACT_APP_DEFAULT_BASE_URL = 'http://localhost:4001';
  const REACT_APP_GET_ABN_URL = '/abnAcnApi/Lookup/GetAbrDetailsByAbn';
  const REACT_APP_GET_ACN_URL = '/abnAcnApi/Lookup/GetAbrDetailsByAcn';

  const ABNACNRef = React.createRef();
  const [typeError, setTypeError] = useState(false);

  const setAbn = props.setAbn ? props.setAbn : () => {};
  const setAcn = props.setAcn ? props.setAcn : () => {};

  useEffect(() => {
    setTypeError(false);
  }, [props.regoType]);

  if (ref) {
    ref.current = {
      validate: () => {
        if (!props.regoType) {
          setTypeError(true);
          return false;
        } else if ((props.regoType === 'ABN' || props.regoType === 'ACN') && ABNACNRef.current) {
          setTypeError(false);
          return ABNACNRef.current.validate();
        }
      },
    };
  }

  const baseURL = props.baseURL ?? REACT_APP_DEFAULT_BASE_URL;
  return (
    <>
      <OrganisationType
        helpMessage={props.helpMessage}
        regoType={props.regoType}
        setRegoType={props.setRegoType}
        disableABN={props.disableABN}
        disableACN={props.disableACN}
        hideHelpMessage={props.hideHelpMessage}
      />
      {typeError ? (
        <div className={'row'}>
          <div className={`col-12 ${styles.errorMessage}`}>
            <ErrorMsg
              className={'ErrorMsg_error'}
              type={'error'}
              description={'Registration type is required.'}
            />
          </div>
        </div>
      ) : null}

      {props.regoType === 'ABN' ? (
        <OrganisationAbnAcn
          title="Registration number"
          searchUrl={`${baseURL}${REACT_APP_GET_ABN_URL}`}
          type={'ABN'}
          value={props.abn}
          abn={props.abn}
          setAbn={setAbn}
          acn={props.acn}
          setAcn={setAcn}
          selectedTradingName={props.selectedTradingName}
          setSelectedTradingName={props.setSelectedTradingName}
          businessName={props.businessName}
          setBusinessName={props.setBusinessName}
          hideTradingNameList={props.hideTradingNameList}
          ref={ABNACNRef}
          errorMessage={`The number entered is not a valid ABN, which has 11 digits. Please check and try again`}
        />
      ) : null}

      {props.regoType === 'ACN' ? (
        <OrganisationAbnAcn
          title="Registration number"
          searchUrl={`${baseURL}${REACT_APP_GET_ACN_URL}`}
          type={'ACN'}
          value={props.acn}
          abn={props.abn}
          setAbn={setAbn}
          acn={props.acn}
          setAcn={setAcn}
          selectedTradingName={props.selectedTradingName}
          setSelectedTradingName={props.setSelectedTradingName}
          businessName={props.businessName}
          setBusinessName={props.setBusinessName}
          hideTradingNameList={props.hideTradingNameList}
          ref={ABNACNRef}
          errorMessage={`The number entered is not a valid ACN, which has 9 digits. Please check and try again.`}
        />
      ) : null}
    </>
  );
};
export default forwardRef(OrganisationWrapped);
